// extracted by mini-css-extract-plugin
export default {"container":"Orientation_container__LPlsz","text":"Orientation_text__T3lLP","instructions_text":"Orientation_instructions_text__Z6CSG","span":"Orientation_span__Z0WqT"};